// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoteClockAssignmentList_container__2NKMu"};